import ssc from './ssc';
// import xyrb from './xyrb';
import pk10 from './pk10';
import ks from './ks';
import choose5 from './choose5';

export default (type, data, ballindex, Vue) => {
  if (type == 'ssc') {
    return ssc(data, ballindex);
  }
  // if (type == 'xyrb') {
  //   return xyrb(data);
  // }
  if (type == 'choose5') {

    return choose5(data, ballindex);
  }
  if (type == 'PK10' || type == 'nn') {
    return pk10(data, ballindex);
  }
  if (type == 'ks') {
    return ks(data, ballindex);
  }
};



// WEBPACK FOOTER //
// ./src/pages/Trend/Dingweizoushi/columns/index.js